class Menu {
  constructor(el) {
    this.el = el;
    this.headerHeight = document.querySelector('[data-header]');
    this.anchorMenuHeight = document.querySelector('[data-anchor-menu]');
    this.imagesLoaded = false;
    this.init();
  }

  init() {
    if (!this.el) {
      return;
    }
    this.elMenuItems = this.el.querySelectorAll('[data-dropdown-menu-item]');
    this.onLoad();
    Array.from(this.elMenuItems).forEach((elMenuItem) => {
      elMenuItem.addEventListener('mouseover', () => {
        this.showMenu(elMenuItem);
      });
      elMenuItem.addEventListener('mouseleave', () => {
        this.hideMenu(elMenuItem);
      });
    });
  }

  showMenu(elMenuItem) {
    elMenuItem.classList.add('active');
  }

  onLoad() {
    const hash = window.location.hash;
    if (!hash) {
      return;
    }
    const id = document.querySelector(hash);

    if (!id) {
      return;
    }

    const offsetTop = document.querySelector(hash).offsetTop;
    const offsetPosition = this.anchorMenuHeight
      ? offsetTop -
        this.headerHeight.offsetHeight +
        this.anchorMenuHeight.offsetHeight
      : offsetTop - this.headerHeight.offsetHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
      duration: 500,
    });
  }

  hideMenu(elMenuItem) {
    const isActive = elMenuItem.classList.contains('active');
    if (isActive) {
      elMenuItem.classList.remove('active');
    }
  }
}

export default Menu;
